<script setup lang="ts">
import { shallowRef, watch, onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import MainLayout from './pages/layouts/MainLayout.vue'
import EmptyLayout from './pages/layouts/EmptyLayout.vue'
import TheLoader from './components/atoms/TheLoader/TheLoader.vue'
import { useUserStore } from '@/stores/userStore'
const route = useRoute()
const layout = shallowRef()
watch(route, (to) => {
    if (to.meta?.layout === 'EmptyLayout') {
        layout.value = EmptyLayout
    } else {
        layout.value = MainLayout
    }
})
useUserStore()

onMounted(() => {
    const appElement = document.getElementById("app");
    let hostname  = window.location.hostname.split(".")[0]
    appElement.classList.add(hostname);
    document.body.classList.add(hostname);

    hostname = window.location.hostname;
    hostname = hostname.replace('staging.', '').replace('.', '-').replace('.', '-'); // remove www. for

    appElement.classList.add(hostname);
    document.body.classList.add(hostname);
})

</script>

<template>
    <TheLoader />
    <component :is="layout">
        <Transition name="fade">
            <RouterView />
        </Transition>
    </component>
</template>
<style lang="scss" scoped>
.fade-enter-active {
    transition: all 0.3s ease-out;
}

.fade-leave-active {
    transition: all 0.3s ease-in;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
